// extracted by mini-css-extract-plugin
export default {"imgProduct":"CardProduct_imgProduct__eYBnd","textDecoration":"CardProduct_textDecoration__J0CrJ","productSummaryImg":"CardProduct_productSummaryImg__+BkH0"};